import * as i0 from '@angular/core';
import * as i1 from './typeahead.module';
import * as i2 from '@angular/common';
import * as i3 from './typeahead-container.component';
import * as i4 from './typeahead.directive';
export const TypeaheadModuleNgFactory:i0.NgModuleFactory<i1.TypeaheadModule> = (null as any);
var _decl0_0:i2.NgClass = (<any>(null as any));
var _decl0_1:i2.NgComponentOutlet = (<any>(null as any));
var _decl0_2:i2.NgForOf<any> = (<any>(null as any));
var _decl0_3:i2.NgIf = (<any>(null as any));
var _decl0_4:i2.NgTemplateOutlet = (<any>(null as any));
var _decl0_5:i2.NgStyle = (<any>(null as any));
var _decl0_6:i2.NgSwitch = (<any>(null as any));
var _decl0_7:i2.NgSwitchCase = (<any>(null as any));
var _decl0_8:i2.NgSwitchDefault = (<any>(null as any));
var _decl0_9:i2.NgPlural = (<any>(null as any));
var _decl0_10:i2.NgPluralCase = (<any>(null as any));
var _decl0_11:i3.TypeaheadContainerComponent = (<any>(null as any));
var _decl0_12:i4.TypeaheadDirective = (<any>(null as any));
var _decl0_13:i2.AsyncPipe = (<any>(null as any));
var _decl0_14:i2.UpperCasePipe = (<any>(null as any));
var _decl0_15:i2.LowerCasePipe = (<any>(null as any));
var _decl0_16:i2.JsonPipe = (<any>(null as any));
var _decl0_17:i2.SlicePipe = (<any>(null as any));
var _decl0_18:i2.DecimalPipe = (<any>(null as any));
var _decl0_19:i2.PercentPipe = (<any>(null as any));
var _decl0_20:i2.TitleCasePipe = (<any>(null as any));
var _decl0_21:i2.CurrencyPipe = (<any>(null as any));
var _decl0_22:i2.DatePipe = (<any>(null as any));
var _decl0_23:i2.I18nPluralPipe = (<any>(null as any));
var _decl0_24:i2.I18nSelectPipe = (<any>(null as any));
var _decl0_25:i2.CommonModule = (<any>(null as any));
var _decl0_26:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_27:i0.ElementRef<any> = (<any>(null as any));
function _View_TypeaheadContainerComponent_Host_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_11.isBs4;
  currVal_0;
  const currVal_1:any = ((_decl0_11.isBs4 && _decl0_11.needScrollbar)? 'scroll': 'visible');
  currVal_1;
  const currVal_2:any = ((_decl0_11.isBs4 && _decl0_11.needScrollbar)? _decl0_11.guiHeight: 'auto');
  currVal_2;
  const currVal_3:any = (_decl0_11.typeaheadScrollable? 'hidden': 'visible');
  currVal_3;
  const currVal_4:any = _decl0_11.dropup;
  currVal_4;
  const pd_5:any = ((<any>_decl0_11.focusLost()) !== false);
  const pd_6:any = ((<any>_decl0_11.focusLost()) !== false);
}
function _View_TypeaheadContainerComponent_1_1():void {
  var _any:any = (null as any);
}
function _View_TypeaheadContainerComponent_1_2():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_11.highlight(_any,_any);
  currVal_0;
}
function _View_TypeaheadContainerComponent_1_5():void {
  if (_any.isHeader()) {
    var _any:any = (null as any);
    const currVal_0:any = _any;
    currVal_0;
  }
}
function _View_TypeaheadContainerComponent_1_7():void {
  if (!_any.isHeader()) { var _any:any = (null as any); }
}
function _View_TypeaheadContainerComponent_1_6():void {
  if (!_any.isHeader()) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_11.isActive(_any);
    currVal_0;
    const currVal_1:any = {item:_any.item,index:_any,match:_any,query:_decl0_11.query};
    currVal_1;
    const currVal_2:any = (_decl0_11.itemTemplate || _decl0_26);
    currVal_2;
    const pd_3:any = ((<any>_decl0_11.selectActive(_any)) !== false);
    const pd_4:any = ((<any>_decl0_11.selectMatch(_any,_any)) !== false);
  }
}
function _View_TypeaheadContainerComponent_1_4():void {
  var _any:any = (null as any);
  const currVal_0:any = _any.isHeader();
  currVal_0;
  const currVal_1:any = !_any.isHeader();
  currVal_1;
}
function _View_TypeaheadContainerComponent_1_3():void {
  var _any:any = (null as any);
  const currVal_0:any = (_decl0_11.needScrollbar? 'scroll': 'auto');
  currVal_0;
  const currVal_1:any = (_decl0_11.needScrollbar? _decl0_11.guiHeight: 'auto');
  currVal_1;
  const currVal_2:any = _decl0_11.matches;
  currVal_2;
}
function _View_TypeaheadContainerComponent_1_10():void {
  if (_any.isHeader()) {
    var _any:any = (null as any);
    const currVal_0:any = _any;
    currVal_0;
  }
}
function _View_TypeaheadContainerComponent_1_12():void {
  if (!_any.isHeader()) { var _any:any = (null as any); }
}
function _View_TypeaheadContainerComponent_1_11():void {
  if (!_any.isHeader()) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_11.isActive(_any);
    currVal_0;
    const currVal_1:any = {item:_any.item,index:_any,match:_any,query:_decl0_11.query};
    currVal_1;
    const currVal_2:any = (_decl0_11.itemTemplate || _decl0_26);
    currVal_2;
    const pd_3:any = ((<any>_decl0_11.selectMatch(_any,_any)) !== false);
    const pd_4:any = ((<any>_decl0_11.selectActive(_any)) !== false);
  }
}
function _View_TypeaheadContainerComponent_1_9():void {
  var _any:any = (null as any);
  const currVal_0:any = _any.isHeader();
  currVal_0;
  const currVal_1:any = !_any.isHeader();
  currVal_1;
}
function _View_TypeaheadContainerComponent_1_8():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_11.matches;
  currVal_0;
}
function _View_TypeaheadContainerComponent_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = {matches:_decl0_11.matches,itemTemplate:_decl0_11.itemTemplate,
      query:_decl0_11.query};
  currVal_0;
  const currVal_1:any = (_decl0_11.optionsListTemplate || (_decl0_11.isBs4? _decl0_26: _decl0_26));
  currVal_1;
}
